import React from 'react';
import { Layout } from 'antd';
import Header from '../header';

function Wrapper(props) {

  return (
    <Layout>
      {!props.hideHeader && <Header tab={props.heading} innerTab={props.innerHeading} reportName={props.reportName} />}
      <Layout
        style={!props.hidePage ? {
          minHeight: 'calc(100vh - 68px)',
        } : {}}
      >
        <Layout style={{ background: '#FAFAFA' }}>
          {props.children}
        </Layout>
      </Layout>
    </Layout>
  );
}

export default Wrapper;
